import { render, staticRenderFns } from "./ConfirmationDialogChangeCategory.vue?vue&type=template&id=60f7bc53"
import script from "./ConfirmationDialogChangeCategory.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogChangeCategory.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDialogChangeCategory.vue?vue&type=style&index=0&id=60f7bc53&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports